module.exports = __webpack_public_path__ + "img/singlecycle.bb02cb8d.svg";